import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Bottom-right floating CTA. Appears after the user scrolls past the hero,
 * hides on /contact, sits above the safe area on mobile, and respects reduced motion.
 */
export function FloatingCTA() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (pathname === '/contact') {
      setVisible(false);
      return;
    }
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [pathname]);

  return (
    <div
      aria-hidden={!visible}
      className={cn(
        'fixed bottom-4 right-4 z-40 transition-all duration-base ease-out-quart sm:bottom-6 sm:right-6',
        visible
          ? 'translate-y-0 opacity-100'
          : 'pointer-events-none translate-y-4 opacity-0',
      )}
      style={{ marginBottom: 'env(safe-area-inset-bottom)' }}
    >
      <Link
        to="/contact"
        className={cn(
          'inline-flex h-11 items-center gap-2 rounded-full border border-gold-500/30',
          'glass px-4 text-sm font-medium text-fg shadow-gold sm:h-12 sm:px-5',
          'transition-all hover:border-gold-500 hover:text-gold-500',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-500',
        )}
      >
        Talk to us
        <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
